import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import CriarExercicioModal from "./criar/CriarExercicioModal.vue";
import EditarExercicioModal from "./editar/EditarExercicioModal.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { ExercicioService } from "../../services/ExercicioService";
export default {
    name: "GerenciarExercicios",
    components: {
        Breadcrumb,
        CriarExercicioModal,
        EditarExercicioModal,
        ActionButtons,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Exercícios',
                disabled: true
            }
        ],
    // Controle de responsividade
    isMobile: false,
    isTablet: false,
    windowWidth: 0,
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px', priority: 1  },
            { text: 'Exercício', align: 'center', value: 'ano', sortable: true },
            { text: 'Status', align: 'center', value: 'ativo', width: '100px', priority: 2 },
        ],
        items: [],
        itemSelected: [],
        modalEdit: false,
        modalCreate: false,
        showFilters: true,
        filters: {
            exercicioFilter: null,
            statusFilter: null
        },
        exerciciosOptions: [],
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        loading: false
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        // Headers computados - sempre mostra todas as colunas
        computedHeaders() {
            // Sempre retorna todas as colunas, independente da resolução
            // O scroll horizontal cuidará da navegação em telas pequenas
            return this.baseHeaders || this.headers;
        }
    },
    created() {
        this.listarExerciciosPaginado();
        this.listarExerciciosSelect();
    },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarExerciciosPaginado();
        },
        'filters.exercicioFilter'(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarExerciciosPaginado();
            }
        },
        'filters.statusFilter'(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarExerciciosPaginado();
            }
        }
    },
    methods: {
        async listarExerciciosPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await ExercicioService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            } finally {
                this.loading = false;
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Todos",
                        value: null,
                    });

                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },
        async destroyExercicios() {
            try {
                const ids = this.itemSelected.map(exercicio => exercicio.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("exercicios[]", id);
                });

                const response = await ExercicioService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os exercícios.');
                }

                this.listarExerciciosPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os exercícios:', error);
            }
        },
        async activateExercicios() {
            try {
                const ids = this.itemSelected.map(exercicio => exercicio.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("exercicios[]", id);
                });

                const response = await ExercicioService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os exercícios.');
                }

                this.listarExerciciosPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os exercícios:', error);
            }
        },
        async deactivateExercicios() {
            try {
                const ids = this.itemSelected.map(exercicio => exercicio.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("exercicios[]", id);
                });

                const response = await ExercicioService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os exercícios.');
                }

                this.listarExerciciosPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os exercícios:', error);
            }
        },
        openModal(value) {
            if (value == 'create') {
                this.modalCreate = true;
            }
            if (value == 'edit') {
                this.modalEdit = true;
            }
        },
        closeActionsDialog() {
            this.modalCreate = false;
        },

        // Métodos para o componente ActionButtons
        navigateToCreate() {
            this.$router.push('/exercicios/criar');
        },
        
        navigateToEdit() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/exercicios/editar/${this.itemSelected[0].id}`);
            }
        },
        
        handleExport() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },

        // Métodos para o componente StandardPagination
        handlePageChanged(newPage) {
            this.page = newPage;
        },
        
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarExerciciosPaginado();
        },

        // Método para selecionar/deselecionar todos os itens
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },

        // Método para mostrar/ocultar filtros
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            this.filters.exercicioFilter
                ? filter.append(
                    "ano",
                    this.filters.exercicioFilter
                )
                : null;

            if (this.filters.statusFilter !== null) {
                filter.append("ativo", this.filters.statusFilter);
            }

            return filter;
        },

        // Método para responsividade
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.isMobile = window.innerWidth <= 768;
            this.isTablet = window.innerWidth <= 1024 && window.innerWidth > 768;
        },

        // Método para classe das linhas da tabela
        getRowClass() {
            return '';
        }
    }
};
